import { FuelUsed } from "@fairfleet/geotab";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_FUEL_USED } from "@/constants/resultsLimits";
import { usePerDeviceQueries } from "@/hooks/usePerDeviceQueries";

export const FUEL_USED_QUERY_KEY = "fuelUsed";

/**
 * Geotab `FuelUsed` events (litres per trip) per device for a period, one query per device.
 */
export function useFuelUsedForDevices(
  deviceIds: string[],
  fromDate: Date,
  toDate: Date,
  enabled = true,
) {
  const { geotabClient } = useGeotabClient();

  return usePerDeviceQueries<FuelUsed>({
    queryKey: FUEL_USED_QUERY_KEY,
    deviceIds,
    fromDate,
    toDate,
    enabled,
    fetchRecords: (deviceId, signal) =>
      geotabClient.get(
        "FuelUsed",
        { deviceSearch: { id: deviceId }, fromDate, toDate },
        RESULTS_LIMIT_FUEL_USED,
        signal,
      ),
  });
}
